module.exports = __webpack_public_path__ + "static/media/sombrero (2).32babf04.png";